import { Component, Input,OnInit } from '@angular/core';
import { ReviewService } from './../review.service';

import { NgFor, NgIf, NgStyle } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FileUploadService } from '../file-upload.service';


export interface Review {
  // id?: number;
  userName: string;
  content: string;
  Page:string;
  rating: number;
  // createdAt?: Date;
}

@Component({
  selector: 'app-showreview',
  standalone:true,
  imports: [NgFor, NgIf, NgStyle, MatIconModule],
  templateUrl: './showreview.component.html',
  styleUrl: './showreview.component.css'
})
export class ShowreviewComponent {
  @Input() reviews: Review[] = []; 
   page: string = ''; // Accept page as an input
  hoveredRating: number | null = null;
 
  constructor(private reviewService: ReviewService,private fileUploadService:FileUploadService) {}
  

  getReviewTextColor(): string {
    
    return this.page === 'Default Request' ? 'white' : '#cf1f25';
  }
  getRatingTextColor(): string {
    
    return this.page === 'Default Request' ? 'white' : '#cf1f25';
  }
  ngOnInit(): void {
    this.loadReviews();

  }

  loadReviews(): void {
    this.fileUploadService.currenticonIdentifierRequest.subscribe(currenticonIdentifierRequest => this.page = currenticonIdentifierRequest);
    this.reviewService.getReviews(this.page).subscribe(data => {
      this.reviews = data;
     
    });
  }
  getDynamicTop(): number {
    

    // Define dynamic top positions based on URL
    if (this.page=="Default Request") {
      return 150;  // Example for home page
    } else {
      return 110;  // Example for about page
    } 
  }
  getDynamicPadding(): number {
    

    // Define dynamic top positions based on URL
    if (this.page=="Default Request") {
      return 1000;  // Example for home page
    } else {
      return 1200;  // Example for about page
    } 
  }
  getStarColor(rating: number): string {
    // this.fileUploadService.currenticonIdentifierRequest.subscribe(currenticonIdentifierRequest => this.page = currenticonIdentifierRequest);
    if(this.page=="Default Request")
    {
      return 'yellow';
    }
    else
    return '#FFD700';
    // if (rating >= 4) return 'gold';
    // if (rating === 3) return 'silver';
    // return 'yellow';
  }

  setHoveredRating(rating: number | null): void {
    this.hoveredRating = rating;
  }
  getStarType(star: number, rating: number): string {
    if (star <= Math.floor(rating)) {
      return 'star'; // Full star
    } else if (star - 0.5 <= rating) {
      return 'star_half'; // Half star
    } else {
      return 'star_border'; // Empty star
    }
  }

}






